<template>
  <div>
    <el-container
      class="h-screen border-card"
      :style="{
        backgroundColor: removeTopAndSidebar
          ? '#ccc !important'
          : '#fff !important',
      }"
    >
      <expired v-if="!showExpired || getSessionIsExpired"></expired>
      <TokenRefresh v-if="!showExpired || getSessionIsExpired"></TokenRefresh>
      <el-drawer
          :visible.sync="drawer"
          :with-header="false"
          direction="ltr"
          :size="200"
      >
        <el-menu id="custom-aside-menu" class="bg-black bg-opacity-80" router>
          <el-menu-item
              index="0"
              style="height: 4rem !important; background-color: #fff !important"
              id="first-menu-item"
          >
            <div class="flex justify-center items-center h-full w-full">
              <img src="@/assets/logo.svg" class="h-12 object-contain w-full" />
            </div>
          </el-menu-item>
          <el-menu-item
              index="1"
              style="height: 4rem !important"
              id="second-menu-item"
              @click="goToOrganization"
          >
            <div class="flex justify-center items-center h-full w-full mb-3">
              <div v-if="loading" class="flex items-center gap-1 h-8 w-8">
                <img
                    class="h-full w-full rounded-full"
                    src="@/assets/icons/loader.gif"
                />
              </div>

              <img v-else :src="info.Logo" class="h-12 object-contain w-full" />
            </div>
          </el-menu-item>

          <div v-for="(menuItem,index) in filteredMenu" :key="index" >
            <el-submenu v-if="menuItem.submenus" :index="menuItem.name">
              <template #title class="text-white">
                <div class="flex flex-row items-center gap-3">
                  <img :src="menuItem.icon" class="h-4" />
                  <span>{{ menuItem.name }}  </span>
                </div>
              </template>

              <el-menu-item
                  v-for="(submenu, subIndex) in menuItem.submenus"
                  :key="subIndex"
              >
                <a :href="`/${getOrganization}/`+submenu.route + `/` +submenu.type" class="flex items-center gap-3 text-white">
                  {{ submenu.name }}
                </a>
              </el-menu-item>
            </el-submenu>


            <el-menu-item v-else>
              <a
                  :href="`/${getOrganization}/${menuItem.route}${menuItem.type ? `/${menuItem.type}` : ''}`"
                  class="flex items-center gap-3 text-white"
              >
                <img :src="menuItem.icon" class="h-4" />
                <span>{{ menuItem.name }}</span>
              </a>
            </el-menu-item>
          </div>
        </el-menu>
      </el-drawer>
      <el-aside
        width="200px"
        class="bg-black bg-opacity-80 hidden lg:block"
        v-if="removeTopAndSidebar"
      >
        <el-menu id="custom-aside-menu" class="bg-black bg-opacity-80">
          <el-menu-item
            index="0"
            style="height: 4rem !important; background-color: #fff !important"
            id="first-menu-item"
          >
            <div class="flex justify-center items-center h-full w-full">
              <img src="@/assets/logo.svg" class="h-12 object-contain w-full" />
            </div>
          </el-menu-item>
          <el-menu-item
            index="1"
            style="height: 4rem !important"
            id="second-menu-item"
            @click="goToOrganization"
          >
            <div class="flex justify-center items-center h-full w-full mb-3">
              <div v-if="loading" class="flex items-center gap-1 h-8 w-8">
                <img
                  class="h-full w-full rounded-full"
                  src="@/assets/icons/loader.gif"
                />
              </div>

              <img v-else :src="info.Logo" class="h-12 object-contain w-full" />
            </div>
          </el-menu-item>

          <div v-for="(menuItem,index) in filteredMenu" :key="index" >
            <el-submenu v-if="menuItem.submenus" :index="menuItem.name">
              <template #title class="text-white">
                <div class="flex flex-row items-center gap-3">
                  <img :src="menuItem.icon" class="h-4" />
                  <span>{{ menuItem.name }}  </span>
                </div>
              </template>

              <el-menu-item-group>
                <el-menu-item v-for="(submenu, subIndex) in menuItem.submenus" :key="subIndex"
                              :index="`${menuItem.name}-${subIndex}`"
                              @click="changeMenu(submenu)">
                  {{ submenu.name }}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>


            <el-menu-item v-else :index="menuItem.name" @click="changeMenu(menuItem)"
                          :class="{ 'bg-primary rounded-md': selectedMenu == menuItem.name }"
                          class="flex flex-row text-white items-center gap-3 pl-2 py-0 cursor-default hover:bg-primary rounded-md my-1 transition ease-in-out delay-75">
              <img :src="menuItem.icon" class="h-4" />
              <span>{{ menuItem.name }}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </el-aside>

      <el-container id="main-container" class="border-card">
        <el-header
          style="
            text-align: right;
            font-size: 12px;
            height: 4rem;
            padding-top: 0.25rem;
          "
          class="my-auto flex bg-white shadow justify-between items-center sticky top-0 z-50"
          v-if="removeTopAndSidebar"
        >
          <div
            @click="drawer = true"
            class="lg:hidden ml-5 flex h-full items-center gap-2"
          >
            <img
              src="@/assets/icons/menu.png"
              class="h-5 object-contain cursor-pointer"
            />
            <img src="@/assets/logo.svg" class="h-12 object-contain" />
          </div>
          <div class="flex ml-auto items-center gap-5">
            <div>
              <img
                @click="showSearch = true"
                class="h-5 w-5 cursor-pointer object-contain inline mr-5"
                src="@/assets/icons/search.png"
              />

              <el-popover
                placement="bottom"
                title="Notifications"
                width="300"
                trigger="hover"
                content=""
              >
                <el-button
                  slot="reference"
                  type="text"
                  style="padding: 0 !important"
                >
                  <div class="bg-primary rounded-full p-1 relative">
                    <img
                      class="h-6 w-6 p-0.5 object-contain inline"
                      src="@/assets/icons/bell.png"
                      @click="goToNotifications"
                    />
                    <span
                      class="absolute top-0 bg-blue-500 text-white rounded-full text-xs right-0 px-1"
                      >{{ ureadNotifications.length }}</span
                    >
                  </div>
                </el-button>
                <main class="h-96 overflow-y-scroll">
                  <section
                    v-for="notification in notifications"
                    :key="notification.id"
                    class="border-b-0.5 mb-3 cursor-pointer hover:bg-gray-300 p-2"
                    @click="goToNotifications(notification)"
                  >
                    <section class="flex gap-3">
                      <h1>{{ notification.title }}</h1>
                      <small class="text-primary font-semibold">{{
                        convertToSentenceCase(notification.type)
                      }}</small>
                    </section>
                    <section>
                      <p>From: {{ notification.createdBy }}</p>
                    </section>
                    <section class="my-2 text-gray-400">
                      <p>{{ getTimePosted(notification.createdAt) }}</p>
                    </section>
                  </section>
                </main>
                <section class="text-center">
                  <button
                    class="font-bold text-center"
                    @click="goToNotifications"
                  >
                    View All
                  </button>
                </section>
              </el-popover>
            </div>
            <div
              class="h-8 w-8 rounded-full flex cursor-pointer"
              @click="goToProfile()"
            >
              <VMenu :placements="bottom" :skidding="-30">
                <div v-if="loading" class="flex items-center gap-1 h-8 w-8">
                  <img
                    class="h-full w-full rounded-full"
                    src="@/assets/icons/loader.gif"
                  />
                </div>

                <div
                  v-else-if="profilePictureUrl"
                  class="flex items-center gap-1 h-8 w-8"
                >
                  <img
                    class="h-full w-full rounded-full"
                    :src="profilePictureUrl"
                  />
                </div>
                <div
                  v-else
                  class="flex items-center gap-1 h-8 w-8 rounded-full"
                >
                  <img
                    v-if="profilePictureUrl && !loading"
                    class="h-full w-full rounded-full"
                    :src="profilePictureUrl"
                    alt="avatar"
                  />

                  <span
                    v-else-if="getUserToView"
                    class="text-primary border-0.5 rounded-full flex items-center justify-center font-bold w-8 h-8"
                  >
                    <img
                      class="h-full w-full rounded-full"
                      src="@/assets/icons/user.png"
                      alt="avatar"
                    />
                  </span>

                  <img
                    v-else
                    class="h-full w-full rounded-full"
                    src="@/assets/icons/user.png"
                    alt="avatar"
                  />
                </div>

                <template #popper>
                  <div class="flex flex-col bg-gray-100">
                    <p
                      @click="goToProfile()"
                      class="cursor-default hover:bg-primary hover:text-white p-2"
                    >
                      View your profile
                    </p>
                    <p
                      @click="changePassword()"
                      class="cursor-default hover:bg-primary hover:text-white p-2"
                    >
                      Change Password
                    </p>
                    <p
                      @click="logOut()"
                      class="cursor-default hover:bg-primary hover:text-white p-2"
                    >
                      Log Out
                    </p>
                  </div>
                </template>
              </VMenu>
            </div>
          </div>
        </el-header>

        <el-main class="border-card">
          <NetworkStatus v-if="false" />

          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <Search :showSearch="showSearch" @close="showSearch = false"></Search>
  </div>
</template>

<style>
.el-header {
  background-color: #fff;

  line-height: 60px;
}

.el-aside {
  background-color: #6b6b6b !important;
  overflow-x: hidden;
}
</style>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import decryptData from './utils/decrypt';
import { viewSecuredAttachment } from './utils/secureAttachmentsViewer';
import Expired from '@/components/auth/expired.vue';
import NetworkStatus from '@/components/network/NetworkStatus.vue';
export default {
  data() {
    return {
      drawer: false,
      imageURL: null,
      user: null,
      role: null,
      selectedMenu: null, // Tracks the currently selected menu
      expandedMenu: null, // Tracks the expanded submenu
      currentUserType: "",
      decryptDataLocal: "",
      decryptionKey: "",
      clickedMenu: "",
      bottom: "bottom",
      showSearch: false,

      profilePictureUrl: null,
      loading: false,
      ureadNotifications: 0,
      notifications: [],

      info: {
        Logo: 'https://www.clker.com/cliparts/b/l/0/w/q/3/modified-generic-company-logo.svg',
      },

      menus: [
        {
          name: 'Dashboard',
          route: 'dashboard',
          icon: require('@/assets/icons/dashboard.png'),
          visibility: ['Employee', 'Manager', 'HR Manager'],
          about: 'View a summary of relevant information about your account',
          keywords: ['Clock In', 'Clock Out', 'Upcoming events'],
          type:''
        },
      /*  {
          name: 'Recruitment',
          route: 'recruitment',
          icon: require('@/assets/icons/user-add.png'),
          visibility: ['HR Manager'],
          about: 'Identify, interview, select, hire and onboard employees',
          keywords: ['Job applications', 'Create Job Position'],
          type:''
        },*/
        {
          name: 'Time & Attendance',
          route: 'time&attendance',
          icon: require('@/assets/icons/clock.png'),
          visibility: ['Employee', 'Manager', 'HR Manager'],
          about: 'Track work hours',
          keywords: ['Clock In', 'Clock Out'],
          type:"mine",
        },
        {
          name: 'Time Off',
          route: 'timeoff',
          icon: require('@/assets/icons/calendar.png'),
          visibility: ['Employee', 'Manager', 'HR Manager'],
          about: 'Take a break from work',
          keywords: ['Apply for leave', 'Leave Days'],
          type: "mine"
        },

        {
          name: 'Employees',
          route: 'employees',
          icon: require('@/assets/icons/users.png'),
          visibility: ['HR Manager', 'Manager'],
          about: 'View your employees',
          keywords: [
            'Bulk Upload employees',
            'Download Bulk Upload template',
            'Add Employee',
          ],
          type:"all"
        },
        {
          name: 'Company',
          route: 'company',
          icon: require('@/assets/icons/building.png'),
          visibility: ['Employee', 'Manager', 'HR Manager'],
          about: 'View your company structure',
          keywords: [
            'Directory',
            'Organogram',
            'Work Hours',
            'Holidays',
            'Knowledge Base',
          ],
          type:"directory"
        },
        {
          name: 'Requests',
          route: 'requests',
          icon: require('@/assets/icons/user-add.png'),
          visibility: ['Admin'],
          about:
            'View, review, approve or decline organizations enrollment request',
          type:''
        },
        {
          name: 'Organizations',
          route: 'organizations',
          icon: require('@/assets/icons/buildings.png'),
          visibility: ['Admin'],
          about: 'View and action on organizations enrolled',
          type:''
        },
        {
          name: 'Admin Setups',
          route: 'admin-setups',
          icon: require('@/assets/icons/settings.png'),
          visibility: ['Admin'],
          about: 'Perform setup required that affect the whole TalantHR',
          type:'',
          keywords: [
            'Email Templates',
            'SMS Templates',
            'Email Gateway',
            'SMS Gateway',
            'Pricing',
            'Licensing',
            'Trial',
          ],
        },
        {
          name: 'Licences',
          route: 'licences',
          icon: require('@/assets/icons/license.svg'),
          visibility: ['Admin'],
          about: 'View licences, both active and inactive.',
          type:''
        },
        {
          name: 'Setups',
          route: 'company-setups',
          icon: require('@/assets/icons/settings.png'),
          visibility: ['HR Manager'],
          about: 'Personalize your organizations to fit you',
          keywords: [
            'Personalize your Organization',
            'Company Setups',
            'Departments',
            'Job Titles',
            'Employment Types',
            'Leave Types',
            'locations',
          ],
          submenus:[
            {
              name:'Core Setups',
              route:"core-setups",
              type:"locations"
            },
            {
              name:'Benefits Setup',
              route: 'benefits-setups',
              type:"benefits"
            },
            {
              name:'Documents Setup',
              route: 'documents-setups',
              type:"documents-setups"
            },
            {
              name:'Claims Setup',
              route: 'claims-setups',
              type:"claims-setups"
            },
            {
              name:'Assets Setup',
              route: 'assets-setups',
              type:"assets-setups"
            },
            {
              name:'Separation Setup',
              route: 'separation-setups',
              type:"separation-setups"
            },
            {
              name:'Timeoff Setup',
              route: 'timeoff-setups',
              type:"timeoff-setups"
            },
            {
              name:'Performance Setup',
              route: 'performance-setups',
              type:"performance-setups"
            },

          ]
        },

        {
          name: 'This Organization',
          route: 'this-organization',
          icon: require('@/assets/icons/ballot.png'),
          visibility: ['HR Manager'],
          about:
            'View, edit and actions on your organization and license information',
          keywords: ['Renew license', 'Licensing Information', ''],
          type:''
        },
        {
          name: 'Announcements',
          route: 'announcements',
          icon: require('@/assets/icons/mic.png'),
          visibility: ['Manager', 'HR Manager'],
          about: 'View and action on announcements in your organization',
          type:''
        },

        {
          name: 'Events',
          route: 'events',
          icon: require('@/assets/icons/event.png'),
          visibility: ['Manager', 'HR Manager'],
          about: 'View and action on events in your organization',
          type:''
        },
        {
          name: 'Reports',
          route: 'reports',
          icon: require('@/assets/icons/doc.png'),
          visibility: ['Manager', 'HR Manager'],
          about: 'View reports based on your organization',
          type:''
        },
       /* {
          name: 'Notifications',
          route: 'notifications',
          icon: require('@/assets/icons/bell.png'),
          visibility: ['Manager', 'HR Manager', 'Employee'],
          about: 'View notification from your organization',
          type:''
        },*/
        {
          name: 'Performance Review',
          route: 'PerformanceReview',
          icon: require('@/assets/icons/star.png'),
          visibility: ['Manager', 'HR Manager', 'Employee'],
          about: 'Perform performance based review',
          keywords: ['360 Evaluation', 'Continous feedback'],
          type:''
        },
        {
          name: 'Users',
          route: 'users',
          icon: require('@/assets/icons/users.png'),
          visibility: ['Admin'],
          about: 'Get a list of all users',
          type:''
        },
        // {
        //   name: "Tasks",
        //   route: "tasks",
        //   icon: require("@/assets/icons/tasks.png"),
        //   visibility: ["Manager", "HR Manager", "Employee"],
        //   about: "Get a list of all tasks",
        // },
        {
          name: 'Training',
          route: 'training',
          icon: require('@/assets/icons/graduation-cap.svg'),
          visibility: ['Employee', 'Manager', 'HR Manager'],
          about: 'Manage team and personal training',
          type:''
        },
      ],
    };
  },
  components: {
    Search: () => import('@/components/search/search.vue'),
    Expired,
    NetworkStatus,
    TokenRefresh: () => import('@/components/auth/TokenRefresh.vue'),
  },

  computed: {
    ...mapGetters([
      'getRouteTo',
      'getUser',
      'getProfileCompletion',
      'getOrganization',
      'getUserType',
      'getToken',
      'getUserToView',
      'getSessionIsExpired',
    ]),
    filteredMenu() {
      var menus = [];
      const userRoleWithSpaces = this.getUserType;

      this.menus.forEach((menu) => {
        if (menu.visibility.includes(userRoleWithSpaces)) {
          menus.push(menu);
        }
      });

      return menus;
    },

    removeTopAndSidebar() {
      var show;
      if (this.validate) {
        show = true;
      }
      if (this.getRouteTo == 'login') {
        show = true;
      } else if (this.getRouteTo == 'register') {
        show = true;
      } else if (this.getRouteTo == 'trial') {
        show = true;
      } else if (this.getRouteTo == 'changePassword') {
        show = true;
      } else if (this.getRouteTo == null) {
        show = true;
      } else if (this.getRouteTo == undefined) {
        show = true;
      } else if (this.getRouteTo == 'NotFound') {
        show = true;
      } else if (this.getRouteTo == 'OrgNotFound') {
        show = true;
      } else {
        show = false;
      }

      return !show;
    },

    showExpired() {
      var show;
      if (this.$route.name == 'login') {
        show = false;
      } else if (this.$route.name == 'enroll') {
        show = false;
      } else if (this.$route.name == 'NotFound') {
        show = false;
      } else if (this.$route.name == null) {
        show = false;
      } else if (this.$route.name == undefined) {
        show = false;
      } else {
        show = true;
      }
      return !show;
    },
  },
  watch: {
    $route(to) {
      this.menus.forEach((menu) => {
        if (menu.route == to.name) {
          this.selectedMenu = menu.name;
        }
      });
      // remove selected menu on profile page
      if (to.name == 'profile') {
        this.selectedMenu = null;
      }
    },

    profilePicture: {
      handler: function () {
        this.viewProfilePicture();
      },
      immediate: true,
    },

    'info.Logo': {
      handler: function () {
        if (!this.imageURL) {
          this.getOrganizationInfo();
          this.$forceUpdate();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.currentUserType = this.getUserType.toLowerCase();
    this.getOrganizationInfo();
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
    this.$store.commit('storeSidebarMenus', this.menus);
    this.menus.forEach((menu) => {
      if (menu.route == this.$route.name) {
        this.selectedMenu = menu.name;
      }
    });
  },
  mounted() {
    this.getOrganizationInfo();
    this.viewProfilePicture();
  },

  methods: {
    getSubmenus(menuName) {

      const menu = this.menus.find((item) => item.name === menuName);
      return menu ? menu.submenus : [];
    },
    getLogo() {
      return this.getOrganizationInfo() || this.info.Logo;
    },
    async viewProfilePicture() {
      try {
        const imageUrl = await viewSecuredAttachment(
          this.getUser.ProfilePicture,
          this.getToken
        );

        this.profilePictureUrl = imageUrl;
      } catch (error) {
        return '';
        // console.error("Error fetching profile picture:", error);
      }
    },
    toggleMenu(menuItem) {
      if (menuItem.submenus){
        this.expandedMenu =
            this.expandedMenu === menuItem.name ? null : menuItem.name;
      } else {
        this.changeMenu(menuItem)
      }
    },
    changeMenu(menu) {
      console.log(menu)
      this.selectedMenu = menu.name;
      this.close();
      this.$router.push({
        name: menu.route,
        params: { company: this.getOrganization, type: menu.type || "" },
      });
      this.drawer = false
    },
    close() {
      this.$emit('closeSideMenu');
    },

    logOut() {
      // this.$store.commit("logout");
      this.$router.replace({
        name: 'login',
        params: { company: this.getOrganization },
      });
      this.$store.commit('logout');
      window.sessionStorage.removeItem('app-data-hrs');
    },
    changePassword() {
      this.$router.replace({
        name: 'changePassword',
        params: { company: this.getOrganization },
      });
    },
    goToNotifications(notification) {
      this.$router.push({
        name: 'notifications',
        params: {
          notification: 'id' in notification ? notification : null,
          company: this.getOrganization,
        },
      });
    },
    goToProfile() {
      this.getEmployeeInfo();
      const user = this.getUser ? this.getUser : {};
      this.$store.commit('setCurrentEmployeeId', user.Id);
      localStorage.setItem('selectedEmployeeId', user.Id);
      this.$router.replace({
        name: 'profile',
        params: {
          user: JSON.stringify(this.user),
          company: this.getOrganization,
        },
      });
    },

    goToOrganization() {
      this.$router.push({
        params: { company: this.getOrganization },
        name: 'this-organization',
      });
    },

    async getOrganizationInfo() {
      if (this.getUser) {
        try {
          const config = {
            headers: {
              Authorization: `Bearer ${this.getToken}`,
            },
          };
          this.loading = true;

          const response = await axios.get(
            `${this.getOrganization}/organization/information/v1/request`,
            config
          );

          this.loading = false;

          if (response.status === 200) {
            this.organizationInfo = response.data;
            const { Id, Name, Address, Email, PhoneNumber, Logo } =
              response.data.Data;
            this.info = {
              ...this.info,
              Id,
              Name,
              Address,
              Email,
              PhoneNumber,
              Logo,
            };
            await this.getOrganizationLogo(Logo);
          }
        } catch (error) {
          console.error(error);
        }
      }
    },

    async getOrganizationLogo(logoUrl) {
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
          responseType: 'arraybuffer',
        };

        const response = await axios.get(logoUrl, config);

        if (response.status === 200) {
          const blob = new Blob([response.data], { type: 'image/png' });
          this.imageURL = URL.createObjectURL(blob);
          this.info.Logo = this.imageURL;
          return this.imageURL;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getEmployeeInfo() {
      try {
        this.loading = true;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
        };

        const response = await axios.get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/general/${this.$ApiVersion}/info`,
          options
        );

        this.loading = false;

        if (response.data.StatusCode === 200) {
          this.employeeInfo = response.data.Data;
          this.user = response.data.Data.PersonalInformation;
          this.$store.commit(
            'setUserToView',
            response.data.Data.PersonalInformation
          );
        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },

    openMenu() {
      this.$emit('openMenu');
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');

* {
  font-family: 'Montserrat', sans-serif;
}

/* Modal transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

/* Center everything */
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/* Accordion transition */
.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}

/* Radio button */
.b-contain *,
.b-contain *::before,
.b-contain *::after {
  box-sizing: content-box !important;
}

.b-contain input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.b-contain span {
  line-height: 1.54;
  font-size: 1rem;
  font-family: inherit;
}

.b-contain {
  display: table;
  position: relative;
  padding-left: 1.8rem;
  cursor: pointer;
  /* margin-bottom: 0.5rem; */
}

.b-contain input[type='radio'] ~ .b-input {
  position: absolute;
  top: 0;
  left: 0;
  height: 1.25rem;
  width: 1.25rem;
  background: rgba(241, 245, 248, 1);
  transition: background 250ms;
  border: 1px solid rgba(184, 194, 204, 1);
  border-radius: 2rem;
}

.b-contain input[type='radio'] ~ .b-input::after {
  content: '';
  position: absolute;
  display: none;
  left: 0.25rem;
  top: 0.25rem;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 2rem;
  background: rgba(255, 255, 255, 1);
  transition: background 250ms;
}

.b-contain input:checked ~ .b-input::after {
  display: block;
}

.b-contain:hover input ~ .b-input,
.b-contain input:focus ~ .b-input {
  background: rgb(231, 238, 243);
}

.b-contain input:focus ~ .b-input {
  box-shadow: 0 0 0 2px #dea42c;
}

.b-contain input:checked ~ .b-input {
  background: #dea42c;
  border-color: #dea42c;
}

.b-contain .b-input::before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 3rem;
  height: 3rem;
  margin-left: -0.85rem;
  margin-top: -0.85rem;
  background: #dea42c;
  border-radius: 2rem;
  opacity: 0.6;
  z-index: 99999;
  transform: scale(0);
}

input,
select,
button {
  border-radius: 0.375rem !important;
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
  height: 32px !important;
}
input[type='checkbox'] {
  height: auto !important;
}

.ve-table-header-th {
  font-weight: bold !important;
  background-color: #e6e4e4 !important;
  font-size: 0.8rem !important;
}
.ve-table-body-td {
  font-size: 0.8rem !important;
}

.el-input__inner,
.el-input__inner:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity)) !important;
  padding: 0.5rem !important;
  height: 36.5px !important;
}

.vdp-datepicker * {
  box-sizing: border-box;
  background-color: transparent;
  outline: none;
  width: 100%;
  cursor: pointer;
}

:focus-visible {
  outline: none;
}

@keyframes b-ripple {
  0% {
    transform: scale(0);
  }

  20% {
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(1);
  }
}

@keyframes b-ripple-duplicate {
  0% {
    transform: scale(0);
  }

  30% {
    transform: scale(1);
  }

  60% {
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(1);
  }
}

.b-contain input + .b-input::before {
  animation: b-ripple 250ms ease-out;
}

.b-contain input:checked + .b-input::before {
  animation-name: b-ripple-duplicate;
}

.b-contain .b-input::before {
  visibility: hidden;
}

.b-contain input:focus + .b-input::before {
  visibility: visible;
}

.b-contain:first-child .b-input::before {
  visibility: hidden;
}

.v-popper--theme-menu .v-popper__inner:hover,
:focus {
  border: none;
  background-color: white;
  resize: none;
  outline: 0;
}

.ve-table .ve-table-cell {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

*,
body {
  font-size: 0.8rem !important;
}

.ve-table
  .ve-table-container
  .ve-table-content-wrapper
  table.ve-table-content
  tbody.ve-table-body
  tr.ve-table-body-tr
  td.ve-table-body-td,
.ve-table
  .ve-table-container
  .ve-table-content-wrapper
  table.ve-table-content
  tbody.ve-table-body
  tr.ve-table-expand-tr
  td.ve-table-body-td {
  padding: 0 4px !important;
  font-size: 0.8rem !important;
}

.ve-table
  .ve-table-container
  .ve-table-content-wrapper
  table.ve-table-content
  thead.ve-table-header
  tr.ve-table-header-tr
  th.ve-table-header-th {
  background-color: #fafafa;
  padding: 0 4px !important;
}
.tox-statusbar__branding {
  display: none !important;
}

.el-dialog__body {
  padding: 0 !important;
}

button#download {
  display: none !important;
  height: 0 !important;
  width: 0 !important;
  visibility: hidden !important;
}

#secondaryDownload {
  display: none !important;
}

#toolbarViewerRight {
  display: none !important;
}
.toolbar {
  display: none !important;
}
div#outerContainer
  div#mainContainer
  div.toolbar
  div#toolbarContainer
  div#toolbarViewer {
  display: none !important;
}

.vdp-datepicker {
  padding: 0 !important;
}

.el-card__body,
.el-main {
  padding: 0 !important;
  margin: 0 !important;
}

.el-menu-item {
  height: 2rem !important;
  color: #fff !important;
  width: 13rem;
  /* margin: 0 auto; */
  border-radius: 10rem;
  /* margin: 0.5rem; */
}
.el-submenu__title{
  color: white !important;
  height: 2rem !important;
  line-height: 2rem !important;
}
.el-submenu {

  background-color: #6b6b6b !important;
  color: white !important;
  padding-left: 15px !important;
}
.el-menu-item-group{
  background-color: #6b6b6b !important;
}
.el-submenu__title:hover{
  background-color: #6b6b6b !important;
}
.el-menu-item:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: #fff;
}

#first-menu-item.el-menu-item {
  position: sticky;
  top: 0;
  z-index: 1;
  border-radius: 0 !important;
  width: 100%;
  margin: 0 auto;
  background-color: white !important;
}
#first-menu-item.el-menu-item:hover {
  background-color: white !important;
}
#second-menu-item.el-menu-item {
  background-color: rgba(0, 0, 0, 0.8) !important;
  border-radius: 0 !important;
  width: 100%;
  margin: 0 auto;
}

#second-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.8) !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: #000;
}
.el-container#main-container {
  flex-direction: column !important;
}
.el-menu {
  background-color: #6b6b6b !important;
}
.el-menu-item-group__title{
  padding: 0 !important;
}
#custom-aside-menu.el-menu {
  border-right: none;

  background-color: #6b6b6b;
  height: 100%;
}
.el-menu-item {
  margin: 0.5rem auto;

}
.el-submenu__title i {
  color: #fff !important;
}
.el-submenu .el-menu-item {
  line-height: 2rem !important;
}
.el-menu-item:focus {
  display: none !important;
}
.el-drawer__body {
  /*background-color: #6b6b6b;*/
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  --tw-bg-opacity: 1;
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: #fff !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(222, 164, 44, var(--tw-bg-opacity)) !important;
  color: #fff !important;
}

.el-dropdown-menu__item,
.el-menu-item {
  cursor: default !important;
}

.font-bold {
  font-weight: 400 !important;
}

.font-semi-bold {
  font-weight: 300 !important;
}
input,
select,
textarea {
  color: #0a0a0ab6 !important;
}
.el-drawer__body .el-menu-item span {
  line-height: 0 !important;
}
.el-menu-item a {
  height: 2rem;
}
</style>
